import React from 'react'

export default function ProIcon(props) {
	return (
		<svg
			width={107}
			height={74}
			viewBox="0 0 107 74"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			{...props}
		>
			<title>Pro Icon</title>
			<defs>
				<path id="a" d="M0 31h43V0H0v14z" />
			</defs>
			<g fill="none" fillRule="evenodd">
				<path
					d="M59.34 55H64v4.691L53.002 66 42 59.69V55h4.66c1.564 1.698 3.819 2.755 6.344 2.755A8.574 8.574 0 0 0 59.34 55zm-6.338-.778c-3.118 0-5.635-2.46-5.613-5.615C47.367 45.486 49.884 43 52.998 43c3.118 0 5.634 2.486 5.613 5.607.021 3.155-2.495 5.615-5.609 5.615z"
					fill="#FFF"
					fillRule="nonzero"
				/>
				<path
					d="M69 50.29l-6.77-10.806-1.519-.877L53 34.155l-16 9.238v20.03l16 9.238 16-9.237V50.29z"
					stroke="#FFF"
					strokeWidth={2}
				/>
				<path
					d="M23.34 55H28v4.691L17.002 66 6 59.69V55h4.66c1.564 1.698 3.819 2.755 6.344 2.755A8.574 8.574 0 0 0 23.34 55zm-6.338-.778c-3.118 0-5.635-2.46-5.613-5.615C11.367 45.486 13.884 43 16.998 43c3.118 0 5.634 2.486 5.613 5.607.021 3.155-2.495 5.615-5.609 5.615z"
					fill="#FFF"
					fillRule="nonzero"
				/>
				<path
					d="M33 63.424V43.393l-8.289-4.786L17 34.155 1 43.393v20.03l16 9.238 16-9.237z"
					stroke="#FFF"
					strokeWidth={2}
				/>
				<path
					d="M41.34 22H46v4.691L35.002 33 24 26.69V22h4.66c1.564 1.698 3.819 2.755 6.344 2.755A8.574 8.574 0 0 0 41.34 22zm-6.338-.778c-3.118 0-5.635-2.46-5.613-5.615C29.367 12.486 31.884 10 34.998 10c3.118 0 5.634 2.486 5.613 5.607.021 3.155-2.495 5.615-5.609 5.615z"
					fill="#FFF"
					fillRule="nonzero"
				/>
				<path
					d="M51 30.424V10.393l-8.289-4.786L35 1.155l-16 9.238v20.03l16 9.238 16-9.237z"
					stroke="#FFF"
					strokeWidth={2}
				/>
				<path
					d="M105 48H64v2h43V19h-2v29z"
					fillOpacity=".2"
					fill="#000"
					fillRule="nonzero"
				/>
				<g fillRule="nonzero" transform="translate(62 17)">
					<use fill="#FFF" fillRule="evenodd" xlinkHref="#a" />
					<path stroke="#FFF" d="M.5 30.5h42V.5H.5v30z" />
				</g>
				<path
					fill="#262E42"
					d="M68 24h31v2H68zm0 8h18v2H68zm21 0h10v2H89zm-21 8h5v2h-5zm9 0h18v2H77z"
				/>
			</g>
		</svg>
	)
}
